/* eslint-disable react/prefer-es6-class, react/prop-types, no-confusing-arrow, react/sort-comp */
import React from 'react';
import * as Paths from 'es6/core/paths';
import { language } from 'es6/helpers/localization';
import { t } from 'es6/services/localization';
import PanelMixin from 'es6/components/home/panel-mixin';
import { ContentFigureSizes, ContentFigure } from 'es6/components/common/content-figure';

const CustomPanel = React.createClass({
  displayName: 'CustomPanel',

  mixins: [PanelMixin],

  getInitialState() {
    return {
      searchBy: '',
    };
  },

  getFilteredGoals() {
    return this.props.goals.filter(this.filterBy).sort((gA, gB) => gA.createdAt > gB.createdAt ? -1 : 1);
  },

  getNoCoursesMessage() {
    return t('course-tabs.custom-courses-no-courses');
  },

  render() {
    const createTitle = t('create a new course');

    return (
      <div className="custom-courses" style={this.getPanelStyle()}>
        <header className="content-details course-filters">
          <div className="details-primary">
            <a href={Paths.createCustomCourse()} className="btn btn-bar narrow warning" data-fancybox-type="ajax" data-modal-link="true" title={createTitle}>{createTitle}</a>
          </div>

          {this.renderSearchBox()}
        </header>

        <section className="courses">
          {this.renderGoals()}
        </section>

        {this.renderPagination()}
      </div>
    );
  },

  renderGoal(goal) {
    return (
      <article key={goal.id} className="content-course">
        <div className="content-columns">
          <ContentFigure size={ContentFigureSizes.SMALL} imgSrc={goal.icon} />

          <section className="content-column course-details">
            <h2 className="course-title ellipsis">
              <a href={Paths.customCourse(goal.id)} title={goal.title}>{goal.title}</a>
            </h2>

            <div className="study-stats">
              <ul className="content-columns study-stats">
                <li className="content-column stat items">
                  <section className="item-data">
                    <span className="primary">{t('items-label')} </span>
                    <span className="secondary">{goal.itemsCount}</span>
                  </section>
                </li>

                <li className="content-column stat sentences">
                  <section className="item-data">
                    <span className="primary">{t('sentences-label')} </span>
                    <span className="secondary">{goal.sentencesCount}</span>
                  </section>
                </li>

                <li className="content-column stat language">
                  <section className="item-data">
                    <span className="primary">{t('language-label')} </span>
                    <span className="secondary">{language(goal.cueLanguage)}</span>
                  </section>
                </li>
              </ul>
            </div>
          </section>

          {this.renderLauncher(goal)}
        </div>
      </article>
    );
  },
});

export default CustomPanel;
